export const CATEGORY_SUMMARY_QUESTIONS_REQUESTED =
    'CATEGORY_SUMMARY_QUESTIONS_REQUESTED';
export const CATEGORY_SUMMARY_QUESTIONS_SUCCESS =
    'CATEGORY_SUMMARY_QUESTIONS_SUCCESS';
export const CATEGORY_SUMMARY_QUESTIONS_FAILURE = 'CATEGORY_SUMMARY_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/ui/types.js